module.exports = __webpack_public_path__ + "img/folder-minus.4d59d4df.svg";